export default "__VITE_ASSET__CvONV77f__"